<mat-nav-list class="app-list" [@listAnimation]="(links|| []).length">
  <a mat-list-item *ngFor="let link of links; trackBy: trackByFn"
    class="app-list__item"
    [routerLink]="link.href"
    routerLinkActive="app-list__item--selected">
    <mat-icon matListIcon *ngIf="link.icon">{{ link.icon }}</mat-icon>
    <h3 matLine>{{ link.name }}</h3>
    <p matLine *ngIf="link.subheading">{{ link.subheading }}</p>
  </a>
</mat-nav-list>